import type { LucideIcon } from "lucide-react";
import type React from "react";

export interface FieldProps {
  icon: LucideIcon;
  label: string;
  visibleAt?: { start: number; end: number };
  children: React.ReactNode;
}

export const Field: React.FC<FieldProps> = ({ icon: Icon, label, visibleAt, children }) => {
  return (
    <div>
      <label className="flex items-center gap-2 text-xs text-slate-300 mb-1.5 md:mb-1">
        <Icon size={12} className="text-slate-500 ml-0.5" />
        <span>{label}</span>
        {visibleAt && (
          <span className="text-slate-500 ml-auto">
            {visibleAt.start}s-{visibleAt.end}s
          </span>
        )}
      </label>
      {children}
    </div>
  );
};
